import { getNewsDetail } from '@/api/api';
import { createRouter } from '../../router'
export default {
  namespaced: true,
  state: {
    getNewsInfo:{
      category: {
        id: 0,
        name: ''
      }
    }
  },
  mutations: {
    setNewsInfo: (state, data) => {
      state.getNewsInfo = data;
    },
  },
  actions: {
    getNewsDetailData({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        getNewsDetail(params).then((response) => {
          commit('setNewsInfo', {})
          if(response.state == 400){
            createRouter().push({path: '/404'})
          }else{
            let _data = JSON.parse(JSON.stringify(response.data));
            let url = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/[\]@!\$&'\*\+,;=.]+$/;
            if (!url.test(_data.source)) {
              _data.isEffectiveWeb = false
            } else {
              _data.isEffectiveWeb = true
            }
            commit('setNewsInfo', _data)
            resolve(response)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/newsInfo.js